import { useQueryClient } from "@tanstack/react-query";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { defaultTextColor, textColor } from "../../../Utils/CommonFunctions";
import { MODULETABS } from "../../../Utils/Constant";

import { useAuth } from "../../../hoc/AuthContext";

import { USER_PROFILE } from "../../../Routes/RoutesContant";

// Map module IDs to API field names
const MODULE_NAME_MAPPING = {
  reward: 'reward_name',
  subscription: 'subscription_name',
  travel: 'travel_name',
  commerce: 'commerce_name',
  membership: 'membership_name',
  experience: 'experience_name',
  loyalty: 'loyalty_name',
  precious_metals: 'precious_metals_name',
  my_account: 'my_account_name',
};

export default function TabModule({ 
  handleModuleClick = () => {},
  activeTab = "",
  websiteHeaderInfo = {},
  myAccountPresent = true,
  homePageType = "",
  hiddenTabIds = [],
}) {
  const { isAuthenticated } = useAuth();
  
  const queryClient = useQueryClient();
  const integratorTheme = queryClient.getQueryData(['integrator-theme', true]) || {};

  const getFilteredTabs = () => {
    // Filter tabs based on _is_present flags from websiteHeaderInfo
    return MODULETABS
      .filter(tab => websiteHeaderInfo[`${tab.id}_is_present`])
      .filter(tab => !hiddenTabIds.includes(tab.id))
      .map(tab => ({
        ...tab,
        title: websiteHeaderInfo?.[MODULE_NAME_MAPPING[tab.id]] || tab.title, // Use custom name or fallback to default title
      }));
  };

  // Optional: Add loading state
  if (isAuthenticated && !websiteHeaderInfo) {
    return <div className="tabModuleSection">
      <div className="animatePulse"></div>
    </div>;
  }

  // Ensure my account tab is included when myAccountPresent or websiteHeaderInfo indicates it
  const tabsToRender = (() => {
    let base = getFilteredTabs();
    const shouldShowMyAccount = myAccountPresent || websiteHeaderInfo?.my_account_is_present;

    if (shouldShowMyAccount && !hiddenTabIds.includes("my_account") && !base.some(t => t.id === "my_account")) {
      const myAccountTemplate = MODULETABS.find(t => t.id === "my_account") || {
        id: "my_account",
        title: "My Account",
        path: USER_PROFILE,
      };
      base.push({
        ...myAccountTemplate,
        title: websiteHeaderInfo?.[MODULE_NAME_MAPPING.my_account] || myAccountTemplate.title,
      });
    }

    // OfferPage now uses the shared rewards route.
    if (homePageType === "OfferPage") {
      base = base.map(tab => 
        tab.id === "reward" 
          ? { ...tab, path: "/rewards" }
          : tab
      );
    }

    return base;
  })();

  return (
    <div className="tabModuleSection">
      {tabsToRender.map((tab) => (
        <Link to={tab.path} key={tab.id} onClick={() => handleModuleClick(tab)}>
          <div
            style={{
              '--moduleTabButtonBackground': activeTab === tab.id ? defaultTextColor(integratorTheme) : '#FFFFFF',
              '--moduleTabButtonColor': activeTab === tab.id ? textColor(integratorTheme) : '#1E1E1E',
              '--moduleTabButtonBorderColor': activeTab === tab.id ? defaultTextColor(integratorTheme) : '#FFFFFF',
            }}
            className={`moduleTabButton ${activeTab === tab.id ? 'active' : ''}`}
          >
            {tab?.title}
          </div>
        </Link>
      ))}
    </div>
  );
};

TabModule.propTypes = {
  handleModuleClick: PropTypes.func,
  activeTab: PropTypes.string,
  websiteHeaderInfo: PropTypes.object,
  myAccountPresent: PropTypes.bool,
  homePageType: PropTypes.string,
  hiddenTabIds: PropTypes.arrayOf(PropTypes.string),
};
